module.exports = __webpack_public_path__ + "static/media/last-movements.2466dfbe.svg";